// TODO: Implement the mapper
// Maps between the API DTO and the Domain Entity
export class ChatSettingsMapper {
  getAllChatTypeToDomain(dto: any): any {
    return dto;
  }

  getApplicableSectorToDomain(dto: any): any {
    return dto;
  }

  getChatChannelConfigToDomain(dto: any): any {
    return dto;
  }

  updateChatChannelConfigToDomain(dto: any): any {
    return dto;
  }

  getConfigDetailToDomain(dto: any): any {
    return dto;
  }

  updateConfigToDomain(dto: any): any {
    return dto;
  }

  getArchivedSectorsToDomain(dto: any): any {
    return dto;
  }

  switchArchiveSectorToDomain(dto: any): any {
    return dto;
  }

  searchUserToDomain(dto: any): any {
    return dto;
  }

  chatSettingsToDomain(dto: any): any {
    return dto;
  }
}
